export const LOCAL_DB_NAME = 'ewu-tpv-local-db';
export const LOCAL_DB_VERSION = 6;

export const LOCAL_DB_STORE_NAMES = [
  'restaurants',
  'restaurant_config',
  'devices',
  'offline_users',
  'rooms',
  'tables',
  'categories',
  'products',
  'product_modifiers',
  'taxes',
  'waiters',
  'open_services',
  'orders',
  'order_lines',
  'payments',
  'print_jobs',
  'pending_actions',
  'sync_state',
  'sync_logs',
  'hub_profiles',
  'local_hub_credentials',
  'qr_delivery_receipts',
];

export const LOCAL_SYNC_STATUS = {
  LOCAL_ONLY: 'local_only',
  PENDING_SYNC: 'pending_sync',
  SYNCING: 'syncing',
  SYNCED: 'synced',
  SYNC_ERROR: 'sync_error',
};

export const LOCAL_ENTITY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
};

const STORE_DEFINITIONS = [
  {
    name: 'restaurants',
    keyPath: 'id',
    indexes: [
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'restaurant_config',
    keyPath: 'restaurant_id',
    indexes: [
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'devices',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['device_type', 'device_type'],
      ['last_seen_at', 'last_seen_at'],
    ],
  },
  {
    name: 'offline_users',
    keyPath: 'id',
    indexes: [
      ['user_id', 'user_id'],
      ['restaurant_id', 'restaurant_id'],
      ['device_id', 'device_id'],
      ['can_login_offline', 'can_login_offline'],
      ['updated_at', 'updated_at'],
      ['last_successful_online_login_at', 'last_successful_online_login_at'],
    ],
  },
  {
    name: 'rooms',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'tables',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['room_id', 'room_id'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'categories',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'products',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['category_id', 'category_id'],
      ['updated_at', 'updated_at'],
      ['available', 'available'],
    ],
  },
  {
    name: 'product_modifiers',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['product_id', 'product_id'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'taxes',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
    ],
  },
  {
    name: 'waiters',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['active', 'active'],
    ],
  },
  {
    name: 'open_services',
    keyPath: 'local_id',
    indexes: [
      ['server_id', 'server_id'],
      ['restaurant_id', 'restaurant_id'],
      ['table_id', 'table_id'],
      ['status', 'status'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'orders',
    keyPath: 'local_id',
    indexes: [
      ['server_id', 'server_id'],
      ['restaurant_id', 'restaurant_id'],
      ['service_local_id', 'service_local_id'],
      ['service_server_id', 'service_server_id'],
      ['table_id', 'table_id'],
      ['status', 'status'],
      ['sync_status', 'sync_status'],
      ['created_at_local', 'created_at_local'],
      ['updated_at_local', 'updated_at_local'],
    ],
  },
  {
    name: 'order_lines',
    keyPath: 'local_id',
    indexes: [
      ['order_local_id', 'order_local_id'],
      ['product_id', 'product_id'],
      ['status', 'status'],
      ['created_at_local', 'created_at_local'],
    ],
  },
  {
    name: 'payments',
    keyPath: 'local_id',
    indexes: [
      ['server_id', 'server_id'],
      ['order_local_id', 'order_local_id'],
      ['restaurant_id', 'restaurant_id'],
      ['payment_method', 'payment_method'],
      ['amount', 'amount'],
      ['status', 'status'],
      ['sync_status', 'sync_status'],
      ['created_at_local', 'created_at_local'],
    ],
  },
  {
    name: 'print_jobs',
    keyPath: 'id',
    indexes: [
      ['restaurant_id', 'restaurant_id'],
      ['status', 'status'],
      ['printer_name', 'printer_name'],
      ['dedupe_key', 'dedupe_key'],
      ['created_at', 'created_at'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'pending_actions',
    keyPath: 'id',
    indexes: [
      ['entity_type', 'entity_type'],
      ['entity_local_id', 'entity_local_id'],
      ['action_type', 'action_type'],
      ['status', 'status'],
      ['created_at', 'created_at'],
      ['retry_count', 'retry_count'],
      ['last_error', 'last_error'],
    ],
  },
  {
    name: 'sync_state',
    keyPath: 'key',
    indexes: [
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'sync_logs',
    keyPath: 'id',
    indexes: [
      ['level', 'level'],
      ['message', 'message'],
      ['created_at', 'created_at'],
      ['entity_type', 'entity_type'],
      ['entity_id', 'entity_id'],
    ],
  },
  {
    name: 'hub_profiles',
    keyPath: 'hub_uuid',
    indexes: [
      ['expires_at', 'expires_at'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'local_hub_credentials',
    keyPath: 'hub_uuid',
    indexes: [
      ['device_uuid', 'device_uuid'],
      ['updated_at', 'updated_at'],
    ],
  },
  {
    name: 'qr_delivery_receipts',
    keyPath: 'delivery_uuid',
    indexes: [
      ['submission_uuid', 'submission_uuid'],
      ['restaurant_id', 'restaurant_id'],
      ['cloud_ack_status', 'cloud_ack_status'],
      ['persisted_at', 'persisted_at'],
    ],
  },
];

function ensureIndex(store, indexName, keyPath, options = {}) {
  if (!store.indexNames.contains(indexName)) {
    store.createIndex(indexName, keyPath, options);
  }
}

export function upgradeLocalDb(db, oldVersion, transaction) {
  STORE_DEFINITIONS.forEach((definition) => {
    const store = db.objectStoreNames.contains(definition.name)
      ? transaction.objectStore(definition.name)
      : db.createObjectStore(definition.name, { keyPath: definition.keyPath });

    definition.indexes.forEach(([indexName, keyPath, options]) => {
      ensureIndex(store, indexName, keyPath, options);
    });
  });

  // Future migrations should be appended here with explicit version checks.
  if (oldVersion < 1) {
    return;
  }

  if (oldVersion < 2) {
    return;
  }

  if (oldVersion < 3) {
    return;
  }

  if (oldVersion < 4) {
    if (!db.objectStoreNames.contains('print_jobs')) {
      const store = db.createObjectStore('print_jobs', { keyPath: 'id' });
      ensureIndex(store, 'restaurant_id', 'restaurant_id');
      ensureIndex(store, 'status', 'status');
      ensureIndex(store, 'printer_name', 'printer_name');
      ensureIndex(store, 'dedupe_key', 'dedupe_key');
      ensureIndex(store, 'created_at', 'created_at');
      ensureIndex(store, 'updated_at', 'updated_at');
    }
  }

  if (oldVersion < 5) {
    // Definitions above create the two control-plane stores and indexes.
  }

  if (oldVersion < 6) {
    // Definitions above create the technical QR receipt store. It is only
    // used for delivery dedupe and ACK retry, never as an operational order.
  }
}
